import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { Invoice } from "@common/types/invoice";
import { getInvoiceUndeliveredSendLabel } from "@common/helpers/domains/invoices/invoiceSentInfo";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatDateForTransaction } from "@helpers/date";
import styles from "./DateCell.module.scss";

export const SentAtCell = memo(
    ({ row }: CellContext<ViewTableFeatures, Invoice, Invoice["sentInfo"]>) => {
        const { sentInfo } = row.original;
        const content = sentInfo?.sentAt
            ? formatDateForTransaction(sentInfo.sentAt)
            : getInvoiceUndeliveredSendLabel(sentInfo);

        return (
            <ViewTableCell className={styles.dateCell}>{content}</ViewTableCell>
        );
    },
);
